import React from 'react';
import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'solid' | 'outline';
}

const MotionButton = motion.button;
const StyledButton = styled(MotionButton)<ButtonProps>`
  border-radius: var(--radius-sm);
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s, border 0.2s;
  border: none;
  background: var(--brand);
  color: #fff;
  padding: 0.7em 2em;
  font-size: 1.1em;
  box-shadow: var(--shadow-sm);
  ${(props) =>
    props.variant === 'outline' &&
    css`
      background: #fff;
      color: var(--brand);
      border: 2px solid var(--brand);
    `}
  ${(props) =>
    props.size === 'lg' &&
    css`
      font-size: 1.2em;
      padding: 1em 2.5em;
    `}
  &:hover {
    background: var(--brand-600);
    color: #fff;
    border-color: var(--brand-600);
    ${(props) =>
      props.variant === 'outline' &&
      css`
        background: var(--brand-50);
        color: var(--brand);
        border-color: var(--brand);
      `}
  }
`;

const Button: React.FC<ButtonProps> = ({ children, ...rest }) => {
  return (
    <StyledButton
      {...rest}
      whileHover={{ scale: 1.05, boxShadow: '0 4px 16px rgba(0,52,196,0.15)' }}
      whileTap={{ scale: 0.97 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      {children}
    </StyledButton>
  );
};

export default Button;
